var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.permittedModules),function(module,index){return _c(module.type,_vm._b({key:index,tag:"component"},'component',_vm.getModuleProperties(module.type),false))}),_c('dash-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }